const options = {
  5: "bg-pink-50/5",
  10: "bg-pink-50/10",
  25: "bg-pink-50/25",
  50: "bg-pink-50/50",
  75: "bg-pink-50/75",
  90: "bg-pink-50/90",
  100: "bg-pink-50",
};

const from = {
  5: "from-pink-50/5",
  10: "from-pink-50/10",
  25: "from-pink-50/25",
  50: "from-pink-50/50",
  75: "from-pink-50/75",
  90: "from-pink-50/90",
  100: "from-pink-50",
};

export default function getBackgroundPink50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
